import { apiClient } from "@/lib/api-client";

import type { RagQualityMetrics, RagQualityMetricsResponse } from "./rag-quality-types";

export async function fetchRagQualityMetrics(): Promise<RagQualityMetrics> {
  const response = await apiClient.get<RagQualityMetricsResponse>("/assistant/rag-quality");
  return response.data;
}
